import React from 'react'

const Unit1A = () => {
  return (
    <div className="p-4 max-w-4xl mx-auto space-y-8">
      <h1 className="text-2xl font-bold">1A Greetings In The Classroom</h1>

      {/* Grammar 1a */}
      <section>
        <h2 className="text-xl font-semibold">1. GRAMMAR – Verb Be [+], Subject Pronouns</h2>
        <h3 className="text-lg font-medium">a. Complete Column 1 with words from the list. Then write the contractions in Column 2.</h3>
        <p className="italic mb-2">Options: she, are, they, is, I, are, is</p>
        <table className="table-auto border w-full text-left">
          <thead>
            <tr>
              <th className="border px-2 py-1">Full Form</th>
              <th className="border px-2 py-1">Contraction</th>
            </tr>
          </thead>
          <tbody>
            <tr><td className="border px-2 py-1">1. I am</td><td className="border px-2 py-1">2. I'm</td></tr>
            <tr><td className="border px-2 py-1">3. you ______</td><td className="border px-2 py-1">4. ________</td></tr>
            <tr><td className="border px-2 py-1">5. he ________</td><td className="border px-2 py-1">6. ________</td></tr>
            <tr><td className="border px-2 py-1">7. ______ is</td><td className="border px-2 py-1">8. ________</td></tr>
            <tr><td className="border px-2 py-1">9. it ______</td><td className="border px-2 py-1">10. ________</td></tr>
            <tr><td className="border px-2 py-1">11. we ______</td><td className="border px-2 py-1">12. ________</td></tr>
            <tr><td className="border px-2 py-1">13. ______ are</td><td className="border px-2 py-1">14. ________</td></tr>
          </tbody>
        </table>
      </section>

      {/* Grammar 1b */}
      <section>
        <h3 className="text-lg font-medium">b. Complete the sentences with ‘m, ‘s, or ‘re.</h3>
        <ol className="list-decimal list-inside space-y-1">
          <li>Hello! You’re in my class.</li>
          <li>I__ Geeta.</li>
          <li>It__ Thursday.</li>
          <li>We___ in room 317.</li>
          <li>She__ in a car.</li>
          <li>They___ doctors.</li>
        </ol>
      </section>

      {/* Grammar 1c */}
      <section>
        <h3 className="text-lg font-medium">c. Complete the conversations with a subject pronoun and ‘m, 's, or ‘re.</h3>
        <p className="italic">Options: I, you, he, she, it, they</p>
        <ol className="list-decimal list-inside space-y-1">
          <li>A: What's your phone number? B: It's ____ 314 892.</li>
          <li>A: How are you? B: __________ fine, thanks.</li>
          <li>Alex and Beth are students. ________ at university in London.</li>
          <li>A: Is Anna in your salsa class? B: No, _________ in my English class!</li>
          <li>Hi! I'm Monika. __________ my partner.</li>
          <li>This is Mark. ____________ your teacher.</li>
          <li>A: Are you and Oliver in Class 2? B: No, ____________ in Class 3.</li>
        </ol>
      </section>

      {/* Pronunciation */}
      <section>
        <h2 className="text-xl font-semibold">2. PRONUNCIATION – Vowel Sounds, Word Stress</h2>
        <h3 className="text-lg font-medium">a. Match the words in the table with their sounds.</h3>
        <p className="italic">ɪ, æ, aɪ, ɛ, iː, eɪ</p>
        <ul className="list-disc list-inside">
          <li>meet – iː</li>
          <li>fine – aɪ</li>
          <li>six – ɪ</li>
          <li>man – æ</li>
          <li>ten – ɛ</li>
          <li>eight – eɪ</li>
          <li>tree – iː</li>
          <li>well – ɛ</li>
          <li>nice – aɪ</li>
          <li>in – ɪ</li>
          <li>thanks – æ</li>
          <li>day – eɪ</li>
        </ul>

        <h3 className="text-lg font-medium">b. Listen and check. Then record the words. (Audio Placeholder)</h3>

        <h3 className="text-lg font-medium">c. Underline the stressed syllable in these words.</h3>
        <ol className="list-decimal list-inside">
          <li>sandwich</li>
          <li>tennis</li>
          <li>eighteen</li>
          <li>thirteen</li>
          <li>basketball</li>
          <li>goodbye</li>
          <li>email</li>
          <li>internet</li>
          <li>computer</li>
          <li>hotel</li>
        </ol>
      </section>

      {/* Vocabulary */}
      <section>
        <h2 className="text-xl font-semibold">3. VOCABULARY – Days of the Week, Numbers 0–20</h2>

        <h3 className="text-lg font-medium">a. Put the letters in order to make days of the week.</h3>
        <ol className="list-decimal list-inside">
          <li>arsaydut – Saturday</li>
          <li>nyauds – ___________</li>
          <li>hrdytusa – ___________</li>
          <li>odnyma – ___________</li>
          <li>dfaryi – ___________</li>
          <li>dsyeeawnd – ___________</li>
          <li>euasdty – ___________</li>
        </ol>

        <h3 className="text-lg font-medium">b. Continue the series.</h3>
        <ol className="list-decimal list-inside">
          <li>five, six, seven, eight, nine, ten __________</li>
          <li>six, eight, ten, __________</li>
          <li>sixteen, seventeen, __________</li>
          <li>five, seven, nine, __________</li>
        </ol>

        <h3 className="text-lg font-medium">c. Complete the words in the dialogues.</h3>
        <ol className="list-decimal list-inside">
          <li>Hello. _'m Priya. Y__'re in my English cl__s.</li>
          <li>Oh! N__e to m__t y__ , Priya.</li>
          <li>N__e to m__t y__ , too.</li>
          <li>Well, s__ y__ on M__d__ , Priya.</li>
          <li>No, the cl__s is on T__sd__ , not M__d__!</li>
          <li>By__ .</li>
          <li>G__dby__ .</li>
        </ol>
      </section>
    </div>
  )
}

export default Unit1A
